// extracted by mini-css-extract-plugin
export default {"productGrid":"a2-z","centerLink":"b2-z","productSection":"c2-z","item":"d2-z","ctaButton":"e2-z"};